import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { values } from '@/utils/enum';
import { translateFilterTimeAxisSpanEnum } from '@/utils/i18n';
import { isEmpty, isNil, uniqueId } from '@/utils/misc';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DateGroupingSelect',
  props: {
    value: { default: () => [] },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ((e: 'input' | 'change', value: FilterTimeAxisSpanEnum[]) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: FilterTimeAxisSpanEnum | FilterTimeAxisSpanEnum[], required: boolean, disabled: boolean, multiple: boolean };





const componentId = uniqueId();
const dateGroupingOptions: FilterTimeAxisSpanEnum[] = values(
  FilterTimeAxisSpanEnum,
).filter((value) => value !== FilterTimeAxisSpanEnum.None);

const { t } = useI18n();

function handleSelect(value: FilterTimeAxisSpanEnum[]) {
  emit('input', value);
  emit('change', value);
}

function isDateGroupingActive(dateGrouping: FilterTimeAxisSpanEnum): boolean {
  if (isNil(props.value)) {
    return false;
  }

  if (Array.isArray(props.value)) {
    return props.value.includes(dateGrouping);
  }

  return props.value === dateGrouping;
}

const multipleSelectionText = computed<string>(() =>
  isEmpty(props.value)
    ? ''
    : (props.value as FilterTimeAxisSpanEnum[])
        .map(translateFilterTimeAxisSpanEnum)
        .join(', '),
);

return { __sfc: true,props, emit, componentId, dateGroupingOptions, t, handleSelect, isDateGroupingActive, multipleSelectionText, translateFilterTimeAxisSpanEnum }
}

})